import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectAgentnetTypesQueryItems } from '../../../../../../redux/agentnet-types/selector';
import { agentnetTypes } from '../../../../../../redux/agentnet-types/action';
import AgentnetComponent from '../components/dbnagent-type.component';

const DBNAgentType = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const AgentnetQuery = useSelector(selectAgentnetTypesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedAgentnetType,
    setSelectedAgentnetType
  ] = useState<any>({})

  const fetchAgentnetTypeById = () => {
    dispatch(agentnetTypes.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/agent-net-types/query`, entity: 'agentnetTypes', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedAgentnetType({ ...selectedAgentnetType, [field]: event });
  }

  useEffect(
    () => {
    
        if (parmas?.id > 0) {
          fetchAgentnetTypeById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedAgentnetType(AgentnetQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const back = () => {
    navigate('/management/dbn-cloud/agentnet/agent-net-types')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <AgentnetComponent
          selectedAgentnetType={selectedAgentnetType}
          handleInnerFormChange={handleInnerFormChange}
          back={back}
        />
      }
    </>
  )

}

export default DBNAgentType;